import LineIcon from '@/components/icons/LineIcon'
import { useLayoutContext } from '@/common/context/useLayoutContext'
import useViewPort from '@/common/hooks/useViewPort'
import { useEffect } from 'react'

const HoverMenuToggle = () => {
  const {
    menu: { size },
    changeMenu: { size: changeMenuSize },
  } = useLayoutContext()
  const { width } = useViewPort()

  useEffect(() => {
    if (width <= 1140) {
      if (size !== 'hidden') changeMenuSize('hidden')
    }
  }, [width])

  const handleHoverMenu = () => {
    if (size === 'sm-hover-active') changeMenuSize('sm-hover')
    else changeMenuSize('sm-hover-active')
  }
  return (
    <button type="button" onClick={handleHoverMenu} className="button-sm-hover " aria-label="Show Full Sidebar">
      <span className="button-sm-hover-icon">
        <LineIcon name="sidebar" size={20} />
      </span>
    </button>
  )
}

export default HoverMenuToggle
